<template>
	<div :class="`app-section`" @click="$emit('click')">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'AppContainer',
		emits: ['click'],
	};
</script>
